import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { TextSize } from "InterfacesTypes/types";


export interface TextSizeState {
  value: TextSize;
  initialized: boolean;
}

const initialState: TextSizeState = {
  value: "normal",
  initialized: false,
};

const textSizeSlice = createSlice({
  name: "textSize",
  initialState,
  reducers: {
    setTextSize(state, action: PayloadAction<TextSize>) {
      state.value = action.payload;
    },
    markInitialized(state) {
      state.initialized = true;
    },
    loadTextSize() {
      // handled by saga
    },
  },
});

export const {
  setTextSize,
  loadTextSize,
  markInitialized,
} = textSizeSlice.actions;

export default textSizeSlice.reducer;
